import { useAuth } from './AuthContext';

/**
 * Hook to check if the current user is an admin
 * Checks for "Admin" role in the JWT token
 */
export const useIsAdmin = () => {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading || !isAuthenticated) {
    return false;
  }

  // Check if user has the Admin role
  const roles = user?.['https://api.the-sidewalk.com/roles'] || [];
  return roles.includes('Admin');
};

/**
 * Hook to check if the user has a specific permission
 */
export const useHasPermission = (permission) => {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading || !isAuthenticated) {
    return false;
  }

  const permissions = user?.['permissions'] || user?.['https://api.the-sidewalk.com/permissions'] || [];
  return permissions.includes(permission);
};

/**
 * Hook to get all user permissions
 */
export const usePermissions = () => {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading || !isAuthenticated) {
    return [];
  }

  return user?.['permissions'] || user?.['https://api.the-sidewalk.com/permissions'] || [];
};
